import "nodelist-foreach-polyfill";
import "./styles/main.scss";
import "./scripts/media-video";
import "./scripts/sidebar";
import "./scripts/mega-menu";
import "./scripts/site-menu";
import "./scripts/site-search";
import "./scripts/accordion";
import "./scripts/news-carousel";
import "./scripts/related-carousel";
import "./scripts/animations";
import "./scripts/print";
import "./scripts/copy-url";
import "./scripts/iframe";
import "./scripts/cookies";

// Vue Instances
import Vue from "vue";
import ListView from "./vue/ListView/ListView.vue";
import CourseList from "./vue/CourseList/CourseList.vue";
import ArticleList from "./vue/KnowlegdeBank/ArticleList/ArticleList.vue";
import HomeView from "./vue/KnowlegdeBank/HomeView/HomeView.vue";

const listViewApp = document.querySelector("#list-view-app");
const courseListApp = document.querySelector("#course-list-app");
const knowledgeBankApp = document.querySelector("#knowledge-bank-app");
const knowlegdeBankListApp = document.querySelector("#knowlegdebank-list");

const backLinks = document.querySelectorAll(".section-header__back");

if (knowledgeBankApp) {
  new Vue({
    el: "#knowledge-bank-app",
    render(h) {
      return h(HomeView, {
        props: {
          bankArticles: this.$el.attributes["data-bankArticles"].value,
          breadcrumb: this.$el.attributes["data-breadcrumb"].value,
          recentlyAddedTitle: this.$el.attributes["data-recentlyAdded"].value,
          searchSection: this.$el.attributes["data-searchSection"].value,
          searchRequestUrl: this.$el.attributes["data-searchRequestUrl"].value,
          searchPlaceholder: this.$el.attributes["data-searchPlaceholder"].value,
          searchButtonText: this.$el.attributes["data-searchButton"].value,
          knowledgeBankTopics: this.$el.attributes["data-topicList"].value,
          title: this.$el.attributes["data-title"].value,
          manchet:this.$el.attributes["data-manchet"].value,
          searchHelpLinkUrl: this.$el.attributes["data-searchHelpLinkUrl"].value,
          searchHelpLinkName: this.$el.attributes["data-searchHelpLinkName"].value
        },
      });
    },
  });
}

if (knowlegdeBankListApp) {
  new Vue({
    el: "#knowlegdebank-list",
    render(h) {
      return h(ArticleList, {
        props: {
          articleItems: this.$el.attributes["data-articleItems"].value,
        },
      });
    },
  });
}

if (listViewApp) {
  new Vue({
    el: "#list-view-app",
    render(h) {
      return h(ListView, {
        props: {
          apiUrl: this.$el.attributes["data-api-url"].value,
          nodeId: parseInt(this.$el.attributes["data-node-id"].value),
          startYear: parseInt(this.$el.attributes["data-start-year"].value),
          websiteType: this.$el.attributes["data-website-type"].value,
        },
      });
    },
  });
} else if (backLinks.length > 0) {
  // Logic to add url params to back links. Data is saved in localStorage
  const goBackUrl = localStorage.getItem("goBackLinkUrl");
  if (goBackUrl != undefined && goBackUrl != "") {
    var substr = goBackUrl.substr(0, goBackUrl.lastIndexOf("/"));
    if (window.location.pathname.indexOf(substr) > -1) {
      backLinks.forEach((backLink) => {
        backLink.setAttribute("href", goBackUrl);
      });
    } else {
      localStorage.removeItem("goBackLinkUrl");
    }
  }
} else {
  // Clear localstorage when a non related url is hit.
  localStorage.removeItem("goBackLinkUrl");
}

if (courseListApp) {
  new Vue({
    el: "#course-list-app",
    render(h) {
      return h(CourseList, {
        props: {
          coursesFileUrl: this.$el.attributes["data-courses-file-url"].value,
          title: this.$el.attributes["data-title"].value,
          manchet: this.$el.attributes["data-manchet"].value,
          textSection: this.$el.attributes["data-text-section"].value,
          breadcrumb: this.$el.attributes["data-breadcrumb"].value,
          endpoint: this.$el.attributes["data-endpoint"].value,
        },
      });
    },
  });
}
